import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IInventoryPurchaseOrderDraftProductInfo,
  IInventoryPurchaseorderInformationCalculationResponse,
  IPOTaxCalculationFields,
} from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setRotaerrorIds } from "@/app_redux/reducers/slices/auth/rota_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryPurchaseOrderInformationCalculationAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (paramsData: IPOTaxCalculationFields) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: IInventoryPurchaseOrderDraftProductInfo[] = await axios
          .post(INVENTORY_MODULE?.PURCHASE_ORDER_INFORMATION_CALCULATION?.baseURL ?? "", paramsData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryPurchaseorderInformationCalculationResponse>) => {
            if (res.data.status === true) {
              return res.data.data;
            } else {
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e)
            return null;
          });
        return response;
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        return null;
      }
    },
    [dispatch],
  );
  return { execute };
};
